import { useState, useEffect } from 'react';
import Axios from 'axios';

export const useFetch = (
  endpoint,
  {
    query,
    selectedFacets,
    facetsLists,
    dateRange,
    selectedTab,
    setSelectedTab,
    tabs,
    cleanQueryString,
    isLoaded
  }
) => {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const params = {};
  const currentKeys = Object.keys(selectedFacets);

  const formatFacets = () => {
    const selectedArray = Object.keys(selectedFacets);
    const selectedDropdowns = facetsLists.filter(
      x => selectedArray.filter(y => x.mainValue === y).length
    );

    const selectedFacetsArray = [...selectedDropdowns].map(dropdown => {
      const currentIds = selectedFacets[dropdown.mainValue];
      const values = currentIds.map(y => {
        const parentFacet = dropdown.facets.filter(z => y === z.value)[0];
        const obj = {};

        if (parentFacet) {
          obj.parentId = parentFacet.value;
          obj.children = parentFacet.childrens
            ? parentFacet.childrens.filter(x => currentIds.includes(x.value))
            : [];

          if (obj.children.length) {
            obj.children = obj.children.map(x => x.value);
          }
        }

        return obj.parentId && obj;
      });

      return {
        [dropdown.mainValue]: values.filter(x => x)
      };
    });
    return [...selectedFacetsArray];
  };

  useEffect(() => {
    const fetchData = async () => {
      if (query) {
        params.query = query;
      }

      if (selectedFacets) {
        params.facets = formatFacets();
      }

      if (dateRange) {
        dateRange.forEach(x => {
          params[x.label] = x.value;
        });
      }

      if (selectedTab) {
        params.searchType = selectedTab.value;
      }

      try {
        setLoading(true);
        const { data } = await Axios({
          method: 'POST',
          url: endpoint,
          data: params
        });
        setResults(data);

        if (!data.resultsList || !data.resultsList.length) {
          if (tabs.length && selectedTab.value !== tabs[0].value) {
            if (Object.keys(selectedFacets).length) {
              // eslint-disable-next-line no-restricted-syntax
              for (const [key] of Object.entries(selectedFacets)) {
                if (selectedFacets[key].length) return;
              }
            }
            cleanQueryString();
            setSelectedTab(tabs[0]);
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    const check = Boolean(
      (query && query.length) ||
        currentKeys.length ||
        dateRange[0].value ||
        dateRange[1].value 
    );

    if (check && isLoaded.current) fetchData();
  }, [query, selectedFacets, facetsLists, dateRange, selectedTab]);

  return { results, loading, currentKeys };
};

export default useFetch;
